import SectionCard from "components/cms/SectionCard";
import BodyBlocks from "components/cms/BodyBlocks";
import { AreaInput, FieldRow, TextInput } from "components/cms/fields";
import { emptyBlock } from "api/article";

export default function NewsletterIssueStack({ form, setForm, setField, frMap }) {
  return (
    <>
      <SectionCard title="Issue" description="Same template as every newsletter issue">
        <FieldRow>
          <TextInput label="Slug" path="slug" form={form} setField={setField} placeholder="issue-9" />
          <TextInput label="Issue number" path="number" form={form} setField={setField} type="number" />
        </FieldRow>
        <FieldRow>
          <TextInput label="Published date" path="publishedAt" form={form} setField={setField} placeholder="2026-09-01" />
          <TextInput label="Read minutes" path="readMinutes" form={form} setField={setField} type="number" />
        </FieldRow>
        <AreaInput label="Title" path="title" form={form} setField={setField} frMap={frMap} rows={2} />
        <AreaInput label="Excerpt" path="excerpt" form={form} setField={setField} frMap={frMap} rows={3} />
      </SectionCard>

      <BodyBlocks
        form={form}
        setForm={setForm}
        setField={setField}
        frMap={frMap}
        emptyBlock={emptyBlock}
        description="Blocks render in the newsletter issue template"
      />
    </>
  );
}
